import { useEffect, useState } from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';
import {useLocation} from "react-router-dom";


const VehicleListDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled, isFetchingActiveVehicleList, activeVehicleList, getActiveVehicleList} = props;

    const theme = useTheme();
    const location = useLocation();

    const [vehicleListData, setVehicleListData] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");
    

    useEffect(() => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                orgUID: organizationId,
            };        

            getActiveVehicleList(parameters);
            
        } else if (!organizationId) {
            getActiveVehicleList();
        }
    }, [storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee])

    useEffect(() => {
        if (activeVehicleList?.length > 0) {
            setVehicleListData(activeVehicleList);
        }
    }, [activeVehicleList])


    const handleChange = (value) => {
        onChange(value);
    }

    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={vehicleListData}
                getOptionLabel={(option) => `${option?.plate_number} - ${option?.model_manufacturer}` || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={value}
                loading={isFetchingActiveVehicleList}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Vehicle not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search vehicle"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isFetchingActiveVehicleList ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default VehicleListDropdownComponent